import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Form, Row, Col, FormGroup, FormControl, Button, ButtonToolbar } from 'react-bootstrap'
import { tableHelper, momentHelper } from './helpers'
import ReactPaginate from 'react-paginate'
import './report.css';
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import IframeModal from '../../component/element/IframeModal'
import Moment from 'moment';
import ReportStore from '../../stores/ReportStore'

var MobileDetect = require('mobile-detect')
class ReportKKCPurchaseOrderSummary extends Component {

  constructor(props) {
    super(props)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    const curDay = parseInt(Moment().format('DD'))
    
    if (this.props.typePrint==='chart') {
      var all_day = Moment(this.props.year-543+'-'+this.props.month, "YYYY-MM").daysInMonth()
    } else {
      var all_day = Moment().daysInMonth()
    }

    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = 'ทั้งเดือน'
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }

    const optionsMonth = [
      { value: 0, label: 'ทั้งปี' },
      { value: 1, label: 'มกราคม' },
      { value: 2, label: 'กุมภาพันธ์' },
      { value: 3, label: 'มีนาคม' },
      { value: 4, label: 'เมษายน' },
      { value: 5, label: 'พฤษภาคม' },
      { value: 6, label: 'มิถุนายน' },
      { value: 7, label: 'กรกฎาคม' },
      { value: 8, label: 'สิงหาคม' },
      { value: 9, label: 'กันยายน' },
      { value: 10, label: 'ตุลาคม' },
      { value: 11, label: 'พฤศจิกายน' },
      { value: 12, label: 'ธันวาคม' }
    ];

    if (this.props.showPrintPreview != true) {
        var defaultMonth = curMonth
        var defaultYear = yTh
        var defaultDay = 0
    } else { 
        var defaultMonth = this.props.month
        var defaultYear = this.props.year
        var defaultDay = this.props.day
    }

    let md = new MobileDetect(window.navigator.userAgent);
    if(md.is('iOS') || md.is("AndroidOS")){ 
      var sliptable_page = "sliptable-page iv-olview"
      var title_desktop = ""
    } else { 
      var sliptable_page = "sliptable-page-desktop iv-olview"
      var title_desktop = "title-desktop"
    }

    this.state = {
      loading:false,
      title_desktop:title_desktop,
      sliptable_page:sliptable_page,
      check_date:[],
      dataFormat:[],
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultMonth: defaultMonth,
      defaultYear: defaultYear,
      defaultDay: defaultDay,
      report_title: 'กำลังดึงข้อมูล..',
      affiliates:[],
      data:[]
    }
  }
  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.defaultYear,this.state.defaultMonth)
    }
  }

  loadData(year,month){
    
    ReportStore.loadReportPurchaseOrderByShop(year,month,this.props.credit,(result)=>{
        this.setState({affiliates:result.affiliates,data:result.data})
    })
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    const optionsDay = []

    if (all_day) {
      for (var i=0;i<=all_day;i++) {
        if (i == 0) {
          var label = 'ทั้งเดือน'
        } else {
          var label = i
        }
        optionsDay.push({
          value: i,
          label: label
        })
      }
      if (all_day<this.state.defaultDay) {
        var defaultDay = 0
      } else {
        var defaultDay = this.state.defaultDay
      }
    } else {
      optionsDay.push({
        value: 0,
        label: 'ทั้งเดือน'
      })
      var defaultDay = 0
    }

    this.setState({ optionsDay: optionsDay, defaultDay:defaultDay })
    return defaultDay
  }

  onYearChange(e) {
    var year = e.value - 543

    var date = year+"-"+this.state.defaultMonth
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultYear: e.value, activePage:1, defaultDay:curDay })
    
    this.loadData(e.value,this.state.defaultMonth)
  }

  onMonthChange(e) {
    let {defaultYear} = this.state
    var date = this.state.defaultYear - 543+"-"+e.value
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultMonth: e.value, activePage:1, defaultDay:curDay })
    this.loadData(defaultYear,e.value)
  }

  onDayChange(e) {
    this.setState({ defaultDay: e.value })
    // this.loadPoAndExpense(this.state.defaultYear - 543, this.state.defaultMonth, e.value, 1, '', this.state.defaultRows)
  }

  onPrintClick() {
    let {defaultMonth,defaultYear} = this.state
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportKKCPurchaseOrderSummary&year='+defaultYear+'&month='+defaultMonth+'&credit='+this.props.credit
    } else{
      url = './pdf/v2/?startPage=PrintReportKKCPurchaseOrderSummary&year='+defaultYear+'&month='+defaultMonth+'&credit='+this.props.credit
    }
    this.refs.iframe.loadUrl(url)
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let value = item[key]
      if (value===''||value===null||value===undefined||isNaN(value))
        value = 0

      sum += parseFloat(value)
    })

    return sum  
  }

  getAllSummary() {
    let {affiliates} = this.state
    let that = this
    let sum = 0
    affiliates.forEach(function(item,index) {
      sum += parseFloat(that.getSummary(item.affiliates_id))
    })              
    return sum
  }
  
  renderTable() {
    let {data,affiliates,defaultMonth,defaultYear} = this.state
    
    return(
      <div className="table-responsive">
        <table className='table table-hover table-bordered-solid table-report-kkc-purchase-order-summary'>
          <thead>
            <tr>
              <th colSpan={14+affiliates.length} className='text-center bg-1'><h2>สรุปยอดการสั่งซื้อวัสดุ - อะไหล่ - สี {defaultMonth===0?'ปี ':'เดือน '+(defaultMonth===1?'มกราคม':defaultMonth===2?'กุมภาพันธ์':defaultMonth===3?'มีนาคม':defaultMonth===4?'เมษายน':defaultMonth===5?'พฤษภาคม':defaultMonth===6?'มิถุนายน':defaultMonth===7?'กรกฎาคม':defaultMonth===8?'สิงหาคม':defaultMonth===9?'กันยายน':defaultMonth===10?'ตุลาคม':defaultMonth===11?'พฤศจิกายน':'ธันวาคม')} {defaultYear}</h2></th>
            </tr>
            <tr>
              <th rowSpan={2} className='text-center bg-2' style={{verticalAlign:'top'}}>สถานที่ซื้อ</th>
              <th className='text-center bg-2'></th>
              <th colSpan={1 + affiliates.length } className='text-center bg-2'>เจ้าของรถ</th>
              <th className='text-center bg-2'>จำนวนเงิน</th>
            </tr>
            <tr>
              <th className='text-center bg-2 color-blue'>สต็อกอู่</th>
              <th className='text-center bg-2 color-blue'>อู่-ลูกค้า</th>
              {affiliates.map((item,index)=>(
                <th key={index} className='text-center bg-2 color-blue'>{item.name}</th>  
              ))}
              <th className='text-center bg-2 color-blue'>{' '}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='text-center color-blue bg-3'><u>เงินสดเชื่อ</u></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              {
                affiliates.map((item,index)=>(
                  <td key={index} className='text-center'></td>
                ))
              }
              <td className='text-center'></td>
            </tr>
            {
              data.map((item,index)=>(
                <tr key={index}>
                  <td>{item.shop_name}</td>
                  <td className='text-right'>{this.getNumberFormat(item.stock)}</td>
                  <td className='text-right'>{this.getNumberFormat(item.customer)}</td>
                  {
                    affiliates.map((aitem,aindex)=>(
                      <td key={aindex} className='text-right'>{item[aitem.affiliates_id]!==undefined?this.getNumberFormat(item[aitem.affiliates_id]):'-'}</td> 
                    ))
                  }                  
                  <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
                </tr>
              ))
            }            
          </tbody>
          <tfoot>
            <tr>
              <th className='bg-2 text-center color-blue'><u>รวมเงินเชื่อ</u></th>
              <th className='bg-2 text-right'>{this.getNumberFormat(this.getSummary('stock'))}</th>
              <th className='bg-2 text-right'>{this.getNumberFormat(this.getSummary('customer'))}</th>
              {
                affiliates.map((item,index)=>(                  
                  <th key={index} className='bg-2 text-right'>{this.getNumberFormat(this.getSummary(item.affiliates_id))}</th>
                ))
              }
              <th className='bg-2 text-right'>{this.getNumberFormat(this.getSummary('amount'))}</th>
            </tr>
            <tr>
              <th className='bg-2 text-center'>ส่วนของลูกค้า</th>
              <th className='bg-2 text-right'>{this.getNumberFormat(this.getSummary('stock')+this.getSummary('customer'))}</th>
            </tr>
            <tr>
              <th className='bg-2 text-center'>ส่วนของในเครื่อ</th>
              <th className='bg-2 text-right'>{this.getNumberFormat(this.getAllSummary())}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  render() {
    let {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          <Box.Title>
            {this.props.renderMenu()}
          </Box.Title>
          <Box.Tools>
            <Button                 
              bsStyle={'link'} className='bg-maroon'
              onClick={this.onPrintClick.bind(this)}
            >
              <FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
            </Button>                            
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          <Form inline>
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultYear }
                options={this.state.optionsYear}
                style={{ width: "80px" }}
                onChange={ this.onYearChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultMonth }
                options={this.state.optionsMonth}
                style={{ width: "120px" }}
                onChange={ this.onMonthChange.bind(this) }
              />
            </FormGroup>
          </Form>
          <br/>
          {this.renderTable()}
        </Box.Body>
        <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
      </Box>
    )
  }

}  

ReportKKCPurchaseOrderSummary.defaultProps = {
  title: '',
  show : false,
  credit:'all'
}
export default ReportKKCPurchaseOrderSummary;


// WEBPACK FOOTER //
// ./src/view/report/ReportKKCPurchaseOrderSummary.js